"use strict";
var appn;
(function (appn) {
    var launchInlineManual;
    (function (launchInlineManual) {
        function init() {
            addEvents();
            const helpWidgetDisabled = appn.localStorage.getItem('helpWidgetDisabled');
            if (helpWidgetDisabled) {
                $('.menuitem-helpAndTuts').closest('.treeview').hide();
                console.warn('Help widget links have been disabled.');
            }
        }
        launchInlineManual.init = init;
        function addEvents() {
            $('.btn-inlinemanual-menuitem').on('click', function (e) {
                e.preventDefault();
                const classes = $(this).prop('class').split(' ');
                let topicId = 0;
                for (const i of classes)
                    if (i.trim().startsWith('topicid'))
                        topicId = i.split('-')[1];
                appn.launchInlineManual.launchTopic(topicId);
            });
            $('.menuitem-helpAndTuts').on('click', function (e) {
                appn.launchInlineManual.wasLoadedSuccessfully();
            });
        }
        function wasLoadedSuccessfully() {
            if (window.hasOwnProperty('inline_manual_player')) {
                appn.localStorage.removeItem('helpWidgetDisabled');
                $('.menuitem-helpAndTuts').closest('.treeview').show();
                return true;
            }
            $('.menuitem-helpAndTuts').closest('.treeview').hide();
            appn.localStorage.setItem('helpWidgetDisabled', true);
            console.warn('Cannot find inline_manual_player obj. Help widget links have been disabled.');
            return false;
        }
        launchInlineManual.wasLoadedSuccessfully = wasLoadedSuccessfully;
        function launchTopic(topicId, stepId) {
            if (!appn.launchInlineManual.wasLoadedSuccessfully())
                return;
            if (!stepId) {
                window.inline_manual_player.activateTopic(topicId);
                return;
            }
            window.inline_manual_player.activateStep(topicId, stepId);
        }
        launchInlineManual.launchTopic = launchTopic;
    })(launchInlineManual = appn.launchInlineManual || (appn.launchInlineManual = {}));
})(appn || (appn = {}));
